/*
* Preserve scroll position during Livewire re-renders
* This solves a lot of problems when using wizards and/or live components that update on every change
*/

document.addEventListener('livewire:initialized', () => {
    let scrollPosition = null;
    let restorePosition = false;

    Livewire.hook('commit', () => {
        scrollPosition = window.scrollY;
        restorePosition = true;
    });

    Livewire.hook('morphed', () => {
        if (!restorePosition) return;

        requestAnimationFrame(() => {
            window.scrollTo(0, scrollPosition);
            restorePosition = false;
        });
    });
});